import {createRouter, createWebHistory} from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('../views/About.vue')
    },
    {
        path: '/group',
        name: 'Group',
        component: () => import('../views/Group.vue')
    },
    {
        path: '/news',
        name: 'News',
        component: () => import('../views/News.vue')
    },
    {
        path: '/contact-us',
        name: 'ContactUs',
        component: () => import('../views/ContactUs.vue')
    },
    {
        path: '/subsidiaries',
        name: 'Subsidiaries',
        component: () => import('../views/Subsidiaries.vue')
    },
    {
        path: '/subsidiaries/:id',
        name: 'SubsidiaryDetails',
        component: () => import('../views/SubsidiariesDetails.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: Home
    }
];


const router = createRouter({
    mode: history,
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash,
                behavior: 'smooth',
                y: 0,
                x: 0
            }
        }
    }
})

router.beforeEach(() => {
    window.scrollTo(0, 0)
})

export default router
